import { render, staticRenderFns } from "./TriggerButtons.vue?vue&type=template&id=4bbf8787&scoped=true"
import script from "./TriggerButtons.vue?vue&type=script&lang=js"
export * from "./TriggerButtons.vue?vue&type=script&lang=js"
import style0 from "./TriggerButtons.vue?vue&type=style&index=0&id=4bbf8787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf8787",
  null
  
)

export default component.exports